var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data flex-center"},[(_vm.showImg)?_c('img',{attrs:{"src":require("@/assets/svgs/no_data.svg"),"alt":""}}):_vm._e(),_c('div',{staticClass:"tip"},[_vm._v("暂无内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }